import type { ReactNode } from 'react';
import Stars from '@/components/Stars';

type StoreBadgeProps = {
  reviewCount: string;
  className?: string;
  icon: ReactNode;
  rating: string;
  label: string;
};

const StoreBadge = ({ className = 'w-[150px]', reviewCount, rating, label, icon }: StoreBadgeProps) => (
  <div className={`${className} flex flex-col gap-1 bg-[#DEF3EB] rounded-xl p-3 shrink-0`}>
    <div className="flex items-center justify-between gap-2">
      <div className="flex items-center gap-2">
        {icon}
        <span className="text-base font-bold">{rating}</span>
      </div>

      <Stars rating={rating} />
    </div>

    <div className="flex items-end mt-auto pt-1 gap-3">
      <div className="text-[11px] leading-tight w-2/3">{label}</div>
      <div className="text-[11px] text-base-300 ml-auto text-right">{reviewCount}</div>
    </div>
  </div>
);

export default StoreBadge;
